/* eslint-disable */
import { errorMsg } from '../constants/messages';
import { acceptableImageFormat } from '../constants/FilterDataValues';

// For regular services (unlimited packages)
const headerServicesFormData = [
  {
    title: 'Service Details',
    name: 'serviceName',
    label: 'Service Name',
    fieldType: {
      name: 'text',
    },
    placeholder: 'e.g., OCI Services, Visa Services, Passport Services, US Services',
    required: true,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'Service Name',
      allowAddRecordClick: true,
    },
    isTableHeader: true,
    isAccordian: true,
  },
  {
    name: 'icon',
    label: 'Icon',
    fieldType: {
      name: 'documitraFile',
      accept: acceptableImageFormat,
      maxCount: '1',
      allowImageCropping: true,
    },
    placeholder: 'Click here to select icon image',
    required: false,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'Icon',
      allowAddRecordClick: false,
      columnType: 'image',
    },
    isTableHeader: true,
    isAccordian: true,
  },
  {
    name: 'serviceUrl',
    label: 'Service URL',
    fieldType: {
      name: 'text',
    },
    placeholder: 'Enter service URL (e.g., /services/oci or https://example.com)',
    required: false,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'Service URL',
      allowAddRecordClick: false,
    },
    isTableHeader: true,
    isAccordian: true,
  },
  {
    name: 'isActive',
    label: 'Is Active',
    fieldType: {
      name: 'radio',
      options: [
        { label: 'Active', value: true },
        { label: 'Inactive', value: false },
      ],
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'Is Active',
      enableSort: false,
      columnType: 'active',
    },
    isTableHeader: true,
    isAccordian: true,
  },
  {
    name: 'sortOrder',
    label: 'Sort Order',
    fieldType: {
      name: 'number',
    },
    placeholder: '0',
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Sort Order', allowAddRecordClick: false },
    isTableHeader: true,
    isAccordian: true,
  },
  {
    title: 'Packages',
    name: 'packages',
    label: 'Packages',
    fieldType: {
      name: 'dynamicPackages',
    },
    placeholder: 'Add packages for this service',
    required: true,
    errorMsg: errorMsg,
    isAccordian: true,
  },
];

// For "Other Services" (unlimited packages) - Only packages section, service settings auto-filled
const otherServicesFormData = [
  {
    title: 'Packages',
    name: 'packages',
    label: 'Packages',
    fieldType: {
      name: 'dynamicPackages',
    },
    placeholder: 'Add packages for this service',
    required: true,
    errorMsg: errorMsg,
    isAccordian: true,
  },
];

export { headerServicesFormData, otherServicesFormData };
